import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../../components/Carousel';
import { usePageLastUpdated } from '../../hooks/usePageLastUpdated';
import './ProjectPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2014-01-30', displayDate: 'January 30, 2014' };

const carouselSlides = [
  {
    backgroundImage: '/images/banner_mercury.png',
    content: (
      <>
        <p>Today, the Internet Service Provider (ISP) market is very competitive.</p>
        <p>
          When ISPs compete for customers with the latest best offers, a question that begs for answers is: how well is
          your ISP connected to your favorite web sites?
        </p>
        <p>Help us find out, by joining our Mercury Internet measurement project and testing your Internet connection.</p>
        <p>
          <a href="#download" className="btn btn--primary" role="button">
            Download Client
          </a>
          {' '}
          <a href="#howto" className="btn btn--primary" role="button">
            How It Works
          </a>
        </p>
      </>
    ),
  },
];

const MercuryPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  return (
    <>
      <Carousel slides={carouselSlides} />
      <div className="project-page" id="top">
        <h1 className="title">Mercury Client</h1>
        <p>Today, the Internet Service Provider (ISP) market is very competitive.</p>
      <p>
        When ISPs compete for customers with the latest best offers, a question that begs for answers is: how well is
        your ISP connected to your favorite web sites?
      </p>
      <p>Help us find out, by joining our Mercury Internet measurement project and testing your Internet connection.</p>

      <div id="download" className="project-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 'var(--spacing-lg)' }}>
        <div>
          <h1>What is Mercury?</h1>
          <p>
            <a href="http://mercury.upf.edu/" target="_blank" rel="noopener noreferrer" className="external">
              Mercury
            </a>{' '}
            is a project of the{' '}
            <a href="http://www.nets.upf.edu/" target="_blank" rel="noopener noreferrer" className="external">
              NeTS Research Group
            </a>{' '}
            at the{' '}
            <a href="http://www.upf.edu/" target="_blank" rel="noopener noreferrer" className="external">
              Pompeu Fabra University
            </a>{' '}
            that measures the Internet topology between subscribers and Internet companies.
          </p>
          <p>
            The Mercury Client is a desktop application that uses a traceroute approach to determine the Internet path
            to a list of the most popular web destinations.
          </p>
        </div>
        <div>
          <h1>No installation required!</h1>
          <p>
            Download and run the Mercury Client application for your operating system. Participating in our project is no
            rocket science! It only takes a few seconds to begin the automated process, and the measurements usually
            take less than 10 minutes.
          </p>
        </div>
        <div>
          <h1>Is it safe?</h1>
          <p>
            No worries, the Mercury Client will not spy on you! What it does is to download a list of web sites, which
            are the most popular for your region. Then it will discover the route by sending small packets to the
            routers leading to each of these destination.
          </p>
        </div>
        <div>
          <h1>More questions?</h1>
          <p>
            The Mercury project is run by{' '}
            <a href="http://www.nets.upf.edu/node/314" target="_blank" rel="noopener noreferrer" className="external">
              Manuel Palacin
            </a>{' '}
            and <Link to="/">Alex Bikfalvi</Link>.
          </p>
          <p>
            <a href="http://mercury.upf.edu/" target="_blank" rel="noopener noreferrer" className="external">
              See Mercury
            </a>
          </p>
        </div>
      </div>

      <hr style={{ margin: 'var(--spacing-xl) 0', border: 'none', borderTop: '1px solid var(--color-border-light)' }} />

      <h1 id="howto">Configure the app.</h1>
      <div className="project-row" style={{ flexDirection: 'row-reverse', gap: 'var(--spacing-xl)' }}>
        <img
          src="/projects/inetanalytics/mercury/MercuryClient_1.png"
          alt="Mercury Client language and country selection."
          style={{ maxWidth: '60%', flex: '1' }}
        />
        <div style={{ flex: '1' }}>
          <p>Choose your preferred language and your country.</p>
          <p>By default, the language of your operating system, if available, and your country will be selected for you.</p>
        </div>
      </div>

      <hr style={{ margin: 'var(--spacing-xl) 0', border: 'none', borderTop: '1px solid var(--color-border-light)' }} />

      <h1>Tell us about your Internet connection.</h1>
      <div className="project-row" style={{ flexDirection: 'row', gap: 'var(--spacing-xl)' }}>
        <img
          src="/projects/inetanalytics/mercury/MercuryClient_2.png"
          alt="Mercury Client connection information."
          style={{ maxWidth: '60%', flex: '1' }}
        />
        <div style={{ flex: '1' }}>
          <p>This information is entirely optional!</p>
          <p>
            But we appreciate if you choose to provide it, since it will help us understand the context of your
            measurement data.
          </p>
        </div>
      </div>

      <hr style={{ margin: 'var(--spacing-xl) 0', border: 'none', borderTop: '1px solid var(--color-border-light)' }} />

      <h1>Start the measurement.</h1>
      <div className="project-row" style={{ flexDirection: 'row-reverse', gap: 'var(--spacing-xl)' }}>
        <img
          src="/projects/inetanalytics/mercury/MercuryClient_3.png"
          alt="Mercury Client measurement."
          style={{ maxWidth: '60%', flex: '1' }}
        />
        <div style={{ flex: '1' }}>
          <p>And have a little patience! Usually, the measurement process will take less than 10 minutes.</p>
          <p>The app will keep you up to date on the progress.</p>
        </div>
      </div>

      <hr style={{ margin: 'var(--spacing-xl) 0', border: 'none', borderTop: '1px solid var(--color-border-light)' }} />

      <h1>Thank you!</h1>
      <div className="project-row" style={{ flexDirection: 'row', gap: 'var(--spacing-xl)' }}>
        <img
          src="/projects/inetanalytics/mercury/MercuryClient_4.png"
          alt="Mercury Client finish."
          style={{ maxWidth: '60%', flex: '1' }}
        />
        <div style={{ flex: '1' }}>
          <p>That's all folks! The measurements have finished, the data has been uploaded and it is now safe to close the app.</p>
        </div>
      </div>

      <p style={{ marginTop: 'var(--spacing-lg)' }}>
        <Link to="/projects/inetanalytics">← Internet Analytics</Link>
      </p>
      <p className="update">Last updated: January 30, 2014</p>
      </div>
    </>
  );
};

export default MercuryPage;
